import styled from 'styled-components';
import Preview from 'gatsby-theme-employees/src/components/preview';

export default styled(Preview)`
  display: block;
`;
